module.exports = __webpack_public_path__ + "img/epr_small.6f031b0e.jpg";